<template>
    <div class="plat_father">
        <el-dialog :title="this.title"
                   :label-position='right'
                   v-if="visibleFlg"
                   v-model="visibleFlg"
                   :close-on-click-modal="false"
                   :close-on-press-escape="true"
                   width="662px"
                   label-width="120px"
        >
            <el-form ref="form" :model="form" :rules="formRules" label-width="90px" class="addForm">
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="平台标识" prop="id">
                            <el-input v-model.trim="form.id" @blur="funTrim($event)" placeholder="请输入内容" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="2"></el-col>
                    <el-col :span="11">
                        <el-form-item label="平台名称" prop="name">
                            <el-input v-model.trim="form.name" @blur="funTrim($event)" placeholder="请输入内容" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="外网地址" prop="ip">
                            <el-input v-model.trim="form.ip" @blur="funTrim($event)" placeholder="请输入内容" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="2"></el-col>
                </el-row>
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="平台版本" prop="version">
                            <el-select v-model="form.version" placeholder="请选择" clearable>
                                <el-option v-for="item in versionSelection" :key="item.key" :label="item.value" :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="2"></el-col>
                    <el-col :span="11">
                        <el-form-item label="其他版本" prop="otherVersion" v-if="form.version==='其他版本'">
                            <el-input v-model.trim="form.otherVersion" @blur="funTrim($event)" placeholder="请输入内容" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="描述" prop="description">
                            <el-input v-model="form.description" @blur="funTrim($event)" type="textarea" :rows='3'></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="5"></el-col>
                    <el-col :span="14">
                        <el-form-item>
                            <el-button style="width:100px" type="primary"  @click="formSubmit('form')" :loading="submitLoading">保存</el-button>
                            <el-button style="width:100px" @click="handleClose()">关闭</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5"></el-col>
                </el-row>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
export default{
    name:'platformAddDialog',
    data(){
        /**
         * @description 外网地址正则校验
         */
        var checkAddress = (rule, value, callback) => {
            let checkRules_1 = /^(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5]):([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/;
            let checkRules_2 = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/;
            if (checkRules_1.test(value) || checkRules_2.test(value)){
                callback();
            } else {
                callback(new Error("请按照格式要求输入地址"));
            }
        };
        return{
            submitLoading: false,
            title:'添加平台',
            visibleFlg: false,
            form:{
                id:'',
                oldSid:'',
                ip:'',
                name:'',
                token:'',
                version:'',
                otherVersion:'',
                description:'',
                createUser:'',
                userId:''
            },
            saveModule:{
                id:'',
                oldSid:'',
                name:'',
                token:'',
                ip:'',
                version:'',
                description:'',
                type:0,
                userId:''
            },
            versionSelection: [
                {
                    key: '8.6',
                    value: '8.6版本'
                },
                {
                    key: '8.7',
                    value: '8.7版本'
                },
                {
                    key: '其他版本',
                    value: '其他版本'
                }
            ],
            formRules:{
                id: [
                    {required: true, message: "请输入平台标识", trigger: 'blur'},
                    {max: 8, message: "注：需要小程序功能的平台唯一标识，长度最大8位", trigger: 'blur'}
                ],
                name: [
                    {required: true, message:"请输入平台名称" ,trigger: 'blur'},
                    {max: 100, message: "请限制平台名称长度在100以内",trigger: 'blur'}
                ],
                ip: [
                    {required: true, message: "例：192.168.10.30:7000或域名edus.cn.utools.club" ,trigger: 'blur'},
                    {max: 200, message: "请限制外网地址长度在200以内", trigger: 'blur'},
                    {validator: checkAddress, trigger:'blur'}
                ],
                version: [
                    {required: true, message:" " , trigger: 'blur'}
                ],
                otherVersion: [
                    {required: true, message:"请输入平台版本" , trigger: 'blur'},
                    {max: 10, message: "请限制平台版本长度在10以内", trigger: 'blur'}
                ],
                description: [
                    {max: 1000, message: "请限制描述内容在1000字以内", trigger: 'blur'}
                ]
            }
        }
    },
    methods: {
        /**
         * @description 删除输入行首尾空格
         */
        funTrim(event){
            event.srcElement.value = event.srcElement.value.trim();
        },
        /**
         * @description 窗体关闭表单置空
         */
        handleClose(){
            this.visibleFlg = false;
            this.submitLoading = false;
            this.$refs["form"].resetFields();
        },
        /**
         * @description 重置表单
         */
        resetForm(formName){
            this.$nextTick(()=>{
                this.$refs[formName].resetFields();
            })
        },
        /**
         * @description 提交表单
         */
        formSubmit(formName){
            this.submitLoading = true;
            this.saveModule.id = this.form.id;
            this.saveModule.oldSid = this.form.oldSid;
            this.saveModule.name = this.form.name;
            this.saveModule.token = this.form.token;
            this.saveModule.ip = this.form.ip;
            if (this.form.version === '其他版本' ) {
                this.saveModule.version = this.form.otherVersion;
            } else {
                this.saveModule.version = this.form.version;
            }
            this.saveModule.description = this.form.description;
            this.saveModule.type = this.form.type;
            this.saveModule.userId = sessionStorage.getItem("sid");
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$api.post(true,"/wxSystem/saveWxSystem",this.saveModule,res=>{
                        if (this.title === '编辑平台'){
                            if (res.data.statusCode === 'API-COMMON-INF-OK') {
                                this.$message.success("修改成功");
                            } else {
                                this.$message.error(res.data.statusMessage);
                            }
                        } else {
                            if (res.data.statusCode === 'API-COMMON-INF-OK') {
                                this.$message.success("添加成功");
                            } else {
                                this.$message.error(res.data.statusMessage);
                            }
                        }
                        this.visibleFlg = false;
                        this.submitLoading = false;
                        this.$parent.queryVo.pageNum = 1;
                        this.$parent.queryMessage();
                    })
                } else {
                    this.$message.error("请检查必填项");
                }
            })
        },
        /**
         * @description 查询到的版本信息，不为预设选项时，需要设置版本信息为其他版本
         */
        alertVersionMessage(){
            this.form.type = 1;
            this.form.oldSid = this.form.id;
            for( let index = 0 ; index < this.versionSelection.length ; index++ ){
                if( this.form.version === this.versionSelection[index].key ){
                    return;
                }
            }
            this.form.otherVersion = this.form.version;
            this.form.version = "其他版本";
        }
    }
}
</script>
<style>
.el-form-item__error {
    width:330px;
    font-size: 12px;
    color: red;
}
.plat_father .el-dialog__header {
    height:36px;
    padding:0px;
    font-size: 14px;
    background-color: rgba(30, 160, 255, 1);
}
.plat_father .el-dialog__title{
    color:white;
    font-size: 14px;
    line-height: 36px;
    padding-left: 20px;
}
.plat_father .el-dialog__headerbtn{
    margin-top: -10px;
}
.plat_father .el-dialog__body{
    padding:20px 20px 0px 20px;
}
.plat_dialog_father .el-dialog__headerbtn .el-dialog__close {
    color:#ffffff;
}
.plat_dialog_father .el-dialog__headerbtn .el-dialog__close:hover{
    color:#bbb5b5;
}
.plat_dialog_father .el-dialog__headerbtn .el-dialog__close:active{
    color:#ffffff;
}
</style>
